import {
  formatAmount,
  formatDateByGroupByTypeChart,
  GroupByType,
  NumberType,
  P,
} from '@vgrubs/components';
import { AreaTooltip } from './charts.style';

export const ChartTooltip = ({
  groupByType,
  currency,
  label,
  payload,
  textColor,
}: {
  groupByType: GroupByType;
  currency: NumberType;
  label: string;
  payload: any;
  textColor?: string;
}) => (
  <AreaTooltip>
    <P $m="0">
      {formatDateByGroupByTypeChart(label, groupByType, true)}
      {': '}
      <span style={{ color: textColor }}>
        {formatAmount(payload?.[0]?.value as number, currency)}
      </span>
    </P>
  </AreaTooltip>
);
